import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
import { Tooltip } from '../../primitives';
import { createResizeObserver } from '../../common/resize-observer';
import * as classNames from 'classnames';
export var ellipsisListKey = 'ellipsis-list';
var EllipsisList = /** @class */ (function (_super) {
    __extends(EllipsisList, _super);
    function EllipsisList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visibleCount: 0
        };
        _this.counterWidth = 60;
        _this.listContainer = null;
        _this.listItems = [];
        _this.allItemsMeasured = false;
        _this.resizeObserver = createResizeObserver(function (w) { return _this.onResize(w); });
        _this.updateVisibleCount = function (listWidth) {
            if (_this.listContainer) {
                var visibleCount = _this.listItems.reduce(function (res, item) {
                    return item.width + item.xOffset + _this.counterWidth < listWidth ? res + 1 : res;
                }, 0);
                if (visibleCount !== _this.state.visibleCount) {
                    _this.setState({ visibleCount: visibleCount });
                }
            }
        };
        _this.onResize = function (width) { return _this.updateVisibleCount(width); };
        _this.measureListItem = function (index) { return function (elem) {
            if (!_this.allItemsMeasured && elem && elem.parentElement) {
                var width = elem.clientWidth;
                var xOffset = elem.offsetLeft - elem.parentElement.offsetLeft;
                var listItem = {
                    index: index, width: width, xOffset: xOffset, elem: elem
                };
                _this.listItems.push(listItem);
                // If this was the last child, all children are now measured
                if (index === React.Children.count(_this.props.children) - 1) {
                    _this.allItemsMeasured = true;
                }
            }
        }; };
        _this.registerListContainer = function (elem) {
            if (elem) {
                _this.listContainer = elem;
                _this.resizeObserver.observeElem(elem);
                _this.updateVisibleCount(elem.clientWidth);
            }
        };
        _this.renderListItem = function (item, idx, measured) {
            var cn = classNames('ellipsis-list-item', { measured: measured });
            var ref = !measured ? _this.measureListItem(idx) : undefined;
            var totalVisible = _this.state.visibleCount;
            var showDelimiter = idx < totalVisible - 1;
            return (React.createElement("li", { key: idx, className: cn, ref: ref },
                item,
                (showDelimiter && _this.listItems.length > 1) ? _this.props.delimiter : null));
        };
        _this.renderHiddenListItem = function (item, idx) {
            var totalHidden = React.Children.count(_this.props.children) - _this.state.visibleCount;
            var showDelimiter = idx < totalHidden - 1;
            return (React.createElement("span", { key: idx, className: 'hidden-list-item' },
                item,
                showDelimiter ? _this.props.delimiter : null));
        };
        return _this;
    }
    EllipsisList.prototype.componentWillUnmount = function () {
        this.resizeObserver.clean();
    };
    EllipsisList.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var childrenArray = React.Children.toArray(props.children);
        var unmeasuredListItems = childrenArray.map(function (child, idx) { return _this.renderListItem(child, idx, false); });
        var visibleListItems = childrenArray.slice(0, state.visibleCount)
            .map(function (child, idx) { return _this.renderListItem(child, idx, true); });
        var hiddenListItems = childrenArray.slice(state.visibleCount);
        var tooltipBody = (React.createElement("div", { className: 'hidden-items-list' }, hiddenListItems.map(function (child, idx) { return _this.renderHiddenListItem(child, idx); })));
        var hiddenItemsContainer = hiddenListItems.length ? (React.createElement("div", { className: 'hidden-count-container' },
            React.createElement(Tooltip, { body: tooltipBody, relativeToBody: props.tooltipRelativeToBody },
                "...",
                React.createElement("span", { className: 'counter' },
                    "(+",
                    hiddenListItems.length,
                    ")")))) : null;
        var cn = namespacedClassnames(ellipsisListKey);
        return (React.createElement("div", { className: cn },
            React.createElement("ul", { className: 'visible-list', ref: this.registerListContainer },
                !this.allItemsMeasured ? unmeasuredListItems : null,
                this.allItemsMeasured ? visibleListItems : null,
                hiddenItemsContainer)));
    };
    return EllipsisList;
}(React.PureComponent));
export { EllipsisList };
//# sourceMappingURL=index.js.map